/* eslint-disable */ /* THIS FILE HAS BEEN GENERATED. DO NOT EDIT IT. */ import { jsx as _jsx } from "react/jsx-runtime";
import { createIcon } from '../utils';
// prettier-ignore
const WarningIcon = createIcon({
    displayName: 'WarningIcon',
    viewBox: '0 0 24 24',
    pathSmall: [
        /*#__PURE__*/ _jsx("path", {
            d: "M11 15c0 .335.073.575.218.735.166.185.428.265.782.265.357 0 .617-.084.782-.268.146-.163.218-.403.218-.732 0-.36-.082-.61-.248-.77-.166-.16-.416-.23-.752-.23-.368 0-.634.106-.799.31-.134.166-.201.397-.201.69Zm1.66-7h-1.33v4.67h1.33V8Z"
        }),
        /*#__PURE__*/ _jsx("path", {
            fillRule: "evenodd",
            d: "M12 4c-5.138 0-8 2.862-8 8 0 5.137 2.862 8 8 8 5.137 0 8-2.863 8-8 0-5.138-2.863-8-8-8Zm0 14.667c-4.424 0-6.667-2.243-6.667-6.667 0-4.424 2.243-6.667 6.667-6.667 4.424 0 6.667 2.243 6.667 6.667 0 4.424-2.243 6.667-6.667 6.667Z",
            clipRule: "evenodd"
        })
    ],
    pathMedium: [
        /*#__PURE__*/ _jsx("path", {
            d: "M10.5 16.5c0 .503.11.862.327 1.103.25.277.642.397 1.173.397.536 0 .925-.126 1.173-.402.219-.244.327-.605.327-1.098 0-.54-.123-.914-.372-1.154C12.88 15.106 12.504 15 12 15c-.552 0-.952.159-1.199.465-.2.249-.301.596-.301 1.035ZM13 13V6h-2v7h2Z"
        }),
        /*#__PURE__*/ _jsx("path", {
            fillRule: "evenodd",
            d: "M12 1C4.936 1 1 4.936 1 12s3.936 11 11 11 11-3.936 11-11S19.064 1 12 1Zm0 20c-5.972 0-9-3.028-9-9 0-5.972 3.028-9 9-9 5.972 0 9 3.028 9 9 0 5.972-3.028 9-9 9Z",
            clipRule: "evenodd"
        })
    ]
});
WarningIcon.defaultProps = {
    fill: 'currentColor',
    boxSize: '24px',
    display: 'block',
    ['data-testid']: 'WarningIcon'
};
export { WarningIcon };

//# sourceMappingURL=warning.js.map